import { render, staticRenderFns } from "./AnalyticsItem.vue?vue&type=template&id=b108effa&scoped=true&"
import script from "./AnalyticsItem.vue?vue&type=script&lang=js&"
export * from "./AnalyticsItem.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsItem.vue?vue&type=style&index=0&id=b108effa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b108effa",
  null
  
)

export default component.exports